import { Box, Card, Divider } from '@zillow/constellation-10';
import { LoadingHeading, LoadingParagraph } from '@zg-rentals/loading-components';

import { PAYMENT_DESCRIPTION_TO_TYPE } from '../../../../constants/PaymentConstants';
import numberUtils from '../../../../utils/numberUtils';

import PaymentTracker from './PaymentTracker';

import { singleTextLineStyles } from '../../../../styles';

import type { PaymentsSummaryResponse } from '../../../../hooks/queries/summary/types';

const PaymentsCard = ({
  title,
  amount,
  description,
  firstName,
  lastName,
  paymentTracker,
  isLoading,
}: PaymentsSummaryResponse['paymentCardList'][number] & { isLoading: boolean }) => (
  <Box css={{ marginBottom: '200' }}>
    <Card tone="neutral" elevated={false} data-test="confirmation-payments-message-card">
      <Box
        css={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: isLoading ? '100' : undefined,
        }}
      >
        <LoadingParagraph textStyle="body-bold" loadingWidth="50%" isLoading={isLoading}>
          {title}
        </LoadingParagraph>
        <LoadingHeading level={5} loadingWidth="10%" isLoading={isLoading}>
          {numberUtils.asCurrency(amount / 100)}
        </LoadingHeading>
      </Box>
      <LoadingParagraph textStyle="body-sm" loadingWidth="100%" isLoading={isLoading} css={{ paddingTop: '400' }}>
        {description}
      </LoadingParagraph>
      <LoadingParagraph
        textStyle="body-sm"
        isLoading={isLoading}
        loadingWidth="100%"
        css={singleTextLineStyles}
        className="fs-mask"
      >
        {firstName} {lastName}
      </LoadingParagraph>
      <Box css={{ marginBlock: '400' }}>
        <Divider />
      </Box>
      {(paymentTracker || isLoading) && (
        // @ts-expect-error
        <PaymentTracker
          paymentType={PAYMENT_DESCRIPTION_TO_TYPE[description?.toLowerCase()] || ''}
          isLoading={isLoading}
          {...(paymentTracker || {
            paymentType: '',
            statusText: '',
            statusType: '',
            trackerStates: [],
          })}
        />
      )}
    </Card>
  </Box>
);

export default PaymentsCard;
